var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGunrunnercardgraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 22,
    viewBox: "0 0 111 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.429 0L3.8135 21.0287H0L0 17.9368L15.8792 0L22.429 0Z",
    fill: "#6A91F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39754 0L0 10.6122L0 3.21086L2.84155 0L9.39754 0Z",
    fill: "#6A91F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5038 0L16.8945 21.0287H10.3447L28.954 0L35.5038 0Z",
    fill: "#6A91F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4921 0L29.8828 21.0287H23.333L41.9423 0L48.4921 0Z",
    fill: "#6A91F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5673 0L42.958 21.0287H36.4082L55.0237 0L61.5673 0Z",
    fill: "#6A91F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6913 0L56.082 21.0287H49.5322L68.1415 0L74.6913 0Z",
    fill: "#6A91F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7727 0L69.1634 21.0287H62.6074L81.2229 0L87.7727 0Z",
    fill: "#6A91F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.761 0L82.1451 21.0287H75.6016L94.2108 0L100.761 0Z",
    fill: "#6A91F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111 0V3.20403L95.2265 21.0287H88.6768L107.286 0L111 0Z",
    fill: "#6A91F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111 10.5273V17.9359L108.258 21.0279H101.708L111 10.5273Z",
    fill: "#6A91F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGunrunnercardgraphic);
export default __webpack_public_path__ + "static/media/gunrunnercardgraphic.457832e2a78c9f02381135b90d0630e2.svg";
export { ForwardRef as ReactComponent };